// src/components/ImageSelectorModal.js
import React, { useEffect, useState } from 'react';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import './Photos.css';

const ImageSelectorModal = ({ projectId, onClose }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [pendingImage, setPendingImage] = useState(null);
  const [caption, setCaption] = useState('');
  const [width, setWidth] = useState('80%');

  useEffect(() => {
    const loadImages = async () => {
      try {
        const snap = await getDocs(collection(db, `projects/${projectId}/photos`));
        const urls = snap.docs.map(doc => ({
          url: doc.data().url,
          name: doc.data().caption || doc.id
        }));
        console.log('Loaded images:', urls);
        setImageUrls(urls);
      } catch (error) {
        console.error('Error loading project images:', error);
      }
    };

    if (projectId) loadImages();
  }, [projectId]);

  const handleImageClick = (url) => {
    setPendingImage(url);
  };

  const handleInsert = () => {
    if (typeof window.selectImageForEditor === 'function') {
      window.selectImageForEditor(pendingImage, caption.trim(), width.trim());
    }
    setPendingImage(null);
    setCaption('');
    setWidth('80%');
    onClose();
  };

  const handleCancel = () => {
    setPendingImage(null);
    setCaption('');
    setWidth('80%');
  };

  return (
    <div className="photo-picker-backdrop">
      <div className="photo-picker-modal">
        <h3>Select an Image</h3>

        {!pendingImage && imageUrls.length > 0 && (
          <div className="image-container">
            {imageUrls.map((img, idx) => (
              <div key={idx} className="image-thumbnail" onClick={() => handleImageClick(img.url)}>
                <img src={img.url} alt={img.name} className="image-thumb" />
                <div className="image-caption">{img.name}</div>
              </div>
            ))}
          </div>
        )}

        {!pendingImage && imageUrls.length === 0 && (
          <p style={{ padding: '1rem', color: '#888' }}>Loading images...</p>
        )}

        {pendingImage && (
          <div className="caption-form" style={{ marginTop: '1rem' }}>
            <h4>Insert Image Options</h4>

            <label style={{ display: 'block', marginBottom: '0.25rem' }}>Caption (optional):</label>
            <input
              type="text"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              placeholder="e.g. North Wall Overview"
              style={{ width: '100%', padding: '0.5rem', marginBottom: '0.75rem' }}
            />

            <label style={{ display: 'block', marginBottom: '0.25rem' }}>Image Width (e.g. 80% or 400px):</label>
            <input
              type="text"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              placeholder="e.g. 80%"
              style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
              <button onClick={handleInsert} className="custom-reports-button">Insert</button>
              <button onClick={handleCancel} className="custom-reports-button">Cancel</button>
            </div>
          </div>
        )}

        {!pendingImage && (
          <button onClick={onClose} className="custom-reports-button" style={{ marginTop: '1rem' }}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageSelectorModal;
